<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">我的请求</span> -->

  <el-container class="list_main_content" :style="conheight">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">我请求的分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container >
      <collapse-search>
      <div class="content_top_wrap">
          <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />

        <el-row style="padding:8px 0px 8px 0px;">
            <el-col :span="24">
              <el-button size="small" type="primary" @click="search('find')"
                >查询</el-button
              >
              <el-button size="small" @click="reset" style="margin-left: 16px;">重置</el-button>
            </el-col>
          </el-row>
      </div>
      </collapse-search>
      <el-main class="request_content">
        

        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          style="width: 100%;"
          header-cell-class-name="myRequest-header-row"
          row-class-name="myRequest-row"
          size="medium"
          height="100%"
          v-loading.fullscreen.lock="fullscreenLoading"
          :default-sort="{ prop: 'status,createTime', order: 'descending' }"
          ref="elTable"
          @selection-change="handleSelectionChange"
        >

          <el-table-column
            type="selection"
            width="40"
            align="left"
            padding-left="0px"
          >
          </el-table-column>
          <!-- <el-table-column
            type="index"
            width="40"
            align="left"
            label="序号"
          ></el-table-column> -->
          <el-table-column
            prop="workOrderNo"
            width="120"
            align="left"
            label="工单号"
            sortable
          ></el-table-column>
          <!--show-overflow-tooltip 控制换行-->
          <el-table-column label="事项名称" >
            <template slot-scope="scope">
              <span
                class="myRequest-subject"
                @click="handleRowClick(scope.row)"
                >{{ scope.row.subject }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="流程名称"
            align="left"
            width="120"
          >

            <template slot-scope="scope">
              <span>{{ scope.row.procDefName }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column            prop="createTime"
            label="创建时间"
            align="left"
            width="160"
            sortable
          ></el-table-column> -->
          <el-table-column 
            label="待审批人"
            align="left"
            width="120"
            sortable
          >
          <template slot-scope="scope">
              <span>{{ scope.row.spr }}</span>
          </template>
          </el-table-column>
          
          <!-- <el-table-column prop="creator" label="发起人" align="left" width="180"></el-table-column> -->
          <el-table-column width="120" align="left" label="状态">
            <template slot-scope="scope">
              <el-badge v-if="scope.row.status == 'revokeToStart' || scope.row.status == 'revoke' || scope.row.status == 'backToStart' || scope.row.status == 'back'" is-dot type="danger"></el-badge>
              <el-badge v-if="scope.row.status == 'draft' || scope.row.status == 'running'" is-dot type="success"></el-badge>
              <el-badge v-if="scope.row.status == 'end' || scope.row.status == 'manualend'" is-dot type="info"></el-badge>



              <!-- primary / success / warning / danger / info -->
              <el-badge v-if="scope.row.status == 'revoke'" size="small" >撤回</el-badge>
              <el-badge v-if="scope.row.status == 'revokeToStart'" size="small" >撤回到发起人</el-badge>

              <el-badge v-if="scope.row.status == 'draft'" size="small" >草稿</el-badge>
              <el-badge v-if="scope.row.status == 'running'" size="small" >运行中</el-badge>

              <el-badge v-if="scope.row.status == 'end'" size="small" >结束</el-badge>
              <el-badge v-if="scope.row.status == 'manualend'" size="small" >人工结束</el-badge>

              <el-badge v-if="scope.row.status == 'back'" size="small" >驳回</el-badge>
              <el-badge v-if="scope.row.status == 'backToStart'" size="small" >驳回到发起人</el-badge>
            </template>
          </el-table-column>

          
          <el-table-column label="操作" align="left" width="100">
            <template slot-scope="scope" >
              <a class="request" @click="deleteDraft(scope.row.id)" v-if="scope.row.status == 'draft'">删除草稿</a>
              <a class="request" @click="deleteBpm(scope.row.id)" v-if="
                  scope.row.status == 'manualend' ||
                    scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' && scope.row.backToStart == true) ||
                    (scope.row.status == 'revoke' && scope.row.backToStart == true)
                ">删除</a>
                <a class="request" @click="doEndProcessById(scope.row.id)" v-if="
                  scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' &&
                      scope.row.backToStart == true)
                ">终止</a>

              <!-- <el-button
                v-if="
                  scope.row.status == 'running' ||
                    scope.row.status == 'back' ||
                    scope.row.status == 'revoke'
                "
                size="mini"
                type="danger"
                @click="handleRevoke(scope.row.id, scope.row.status)"
                >撤回</el-button
              > -->
              <!-- <el-button
                v-if="scope.row.status == 'draft'"
                size="mini"
                type="danger"
                @click="deleteDraft(scope.row.id)"
                >删除草稿</el-button
              > -->
              <!-- <el-button
                v-if="
                  scope.row.status == 'manualend' ||
                    scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' && scope.row.backToStart == true) ||
                    (scope.row.status == 'revoke' && scope.row.backToStart == true)
                "
                size="mini"
                type="danger"
                @click="deleteBpm(scope.row.id)"
                >删除</el-button
              > -->
              <!-- <el-button
                style="margin-top: 0px;"
                v-if="
                  scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' &&
                      scope.row.backToStart == true)
                "
                size="mini"
                type="danger"
                @click="doEndProcessById(scope.row.id)"
                >终止</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row>
          <div style="display: initial;">
            <span style="padding-right:16px;font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #52535E;">已选 {{arrlen}}条</span>
            <el-button  size="small" @click="taskToCopyTo()">传阅</el-button>
          </div>
          <div style="float: right;display: initial;">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-row>
      </el-footer>
      <el-dialog
        title="撤回到发起人"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          placeholder="请输入撤回意见"
          v-model="opinion"
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRevoke" size="small"
            >确 定</el-button
          >
          <el-button @click="exitRevoke" size="small">取 消</el-button>
        </div>
      </el-dialog>
       <!-- 流程传阅-->
      <TaskToCopyTo ref="taskToCopyTo" :instId="selectId" />     
    </el-container>
  </el-container>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process.js";
import searchForm from "@/components/common/searchForm.vue";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";


export default {
  name: "myRequest",
  components: {
    FlowTree,
    searchForm,
    TaskToCopyTo
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectId:'',
      arrlen:0,
      activeNames: "",
      // isExpand: false,
      form: { tableData: "", date: "", orgName: "", orgId: "" },
      conheight: { height: "" },
      asideShow: false,
      opinion:"",
      dialogFormVisible:false,
      currentTree: "",
      fullscreenLoading: true,
      sorter: [],
      urgentStateConf: {},
      urgentStateConfList: [],
      urgentStateVal: "",
      ids: "", //待办任务id集合
      defaultFiledShowConf: "",
      defaultFiledShowConfList: [
        { name: "subject", desc: "标题", frontShow: true },
        { name: "workOrderNo", desc: "工单号", frontShow: true},
        { name: "procInstId", desc: "流程编号", frontShow: true },
        { name: "procDefName", desc: "流程名称", frontShow: true},
        { name: "name", desc: "任务名称", frontShow: true },
        { name: "status", desc: "类型", frontShow: true },
        { name: "createTime", desc: "创建时间", frontShow: true },
        { name: "creator", desc: "创建人", frontShow: true },
        { name: "urgentStateValue", desc: "紧急状态", frontShow: true },
        { name: "dueExpDate", desc: "到期时间", frontShow: false },
        { name: "ownerName", desc: "所属人", frontShow: false },
        { name: "assigneeName", desc: "待审批人", frontShow: true },
        { name: "prop1", desc: "扩展1", frontShow: false },
        { name: "prop2", desc: "扩展2", frontShow: false },
        { name: "prop3", desc: "扩展3", frontShow: false },
        { name: "prop4", desc: "扩展4", frontShow: false },
        { name: "prop5", desc: "扩展5", frontShow: false },
        { name: "prop6", desc: "扩展6", frontShow: false }
      ],
      history: [],
      searchOptions: [
        {
          property: "a.subject_",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "a.work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        },
        {
          property: "a.proc_def_name_",
          operation: "LIKE",
          type: "text",
          label: "流程名称",
          placeholder: "请输入流程名称"
        },
        {
          property: "a.create_time_",
          operation: "IN",
          type: "datetimerange",
          label: "创建时间"
        },
        {
          label: "状态",
          property: "a.status_",
          operation: "EQUAL",
          type: "select",
          placeholder: "请选择状态",
          options: [
            {
          value: "",
          label: "全部",
        },
        {
          value: "revoke",
          label: "撤回",
        },
        {
          value: "back",
          label: "驳回",
        },
        {
          value: "end",
          label: "结束",
        },
        {
          value: "running",
          label: "运行中",
        }
          ]
        }
      ]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total,
  }),
  methods: {
     //页面高度
    getHeight(){
      this.conheight.height = window.innerHeight -64 + "px";
    },
    //流程传阅
    taskToCopyTo() {
      let {selection} = this.$refs.elTable;
      let ids = [];
      selection.forEach(item=>{
       ids.push(item.id);
      })
      //todo 判断ids是不是空的
      this.selectId = ids.join(",")
      if(this.selectId==""){
        this.$message.warning("请选择要传阅的流程");
        return;
      }
      this.$refs.taskToCopyTo.handleClose(); //父组件调用子组件方法
    },
        //批量勾选待办流程获取
    handleSelectionChange(val) {
      this.arrlen=0;//初始化
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.arrlen += 1;
        }
      }
    },
    //选择状态查询
    statusChange(value) {
      this.statusData = value;
      this.search("find");
    },
    handleClose(done) {
      this.dialogFormVisible = true;
    },
    //逻辑删除流程实例
    deleteBpm(id) {
      this.$confirm("确认删除此流程?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$store.dispatch("storeProcess/restore", id).then(() => {
          this.search("find");
        });
      });
    },
    //终止流程
    doEndProcessById(id) {
      this.$confirm("确认终止此流程?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false
      }).then(() => {
        this.$store.dispatch("storeProcess/doEndProcessById", id).then(() => {
          this.search("find");
        });
      });
    },
    //删除草稿
    deleteDraft(id) {
      this.$store.dispatch("storeProcess/removeDraftById", id).then(() => {
        this.search("find");
      });
    },
    //撤回到发起人
    handleRevoke(id, status) {
      if (status == "revokeToStart") {
        this.$message.warning("已撤回，不能再撤回");
        return false;
      }
      this.dialogFormVisible = true;
      this.id = id;
    },
    saveRevoke() {
      if (this.opinion == "") {
        this.$message.warning("请填写撤回意见");
        return false;
      }
      let data = {
        instanceId: this.id,
        isHandRevoke: false,
        cause: this.opinion,
      };
      this.$store.dispatch("storeProcess/revokeInstance", data).then(() => {
        this.dialogFormVisible = false;
        this.opinion = "";
        this.search();
      });
    },
    exitRevoke() {
      this.dialogFormVisible = false;
      this.opinion = "";
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      if (this.currentTree) {
        querys.push({
          property: "bt.type_id_",
          value: this.currentTree,
          group: "typeId",
          operation: "IN",
          relation: "AND"
        });
      }
      if (this.defKey) {
        querys.push({
          property: "bt.proc_def_key_",
          value: this.defKey,
          operation: "EQUAL",
          relation: "AND"
        });
      }
      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getMyRequestByPagination", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      if (row.status == "draft") {
        //this.$router.push("/start/" + row.procDefId + "/" + row.id);
        url += "/start/" + row.procDefId + "/" + row.id;
      } else if (row.status == "end" || row.status == "manualend") {
        //this.$router.push("/instRead/" + row.id+"/myRequest");
        url += "/instRead/" + row.id + "/myRequest";
      } else {
        //this.$router.push("/inst/" + row.id + "/request");
        url += "/inst/" + row.id + "/request";
      }
      url += "?token=" + token;
      let windowObj = window.open(url,"_blank","width="+(window.screen.availWidth-10)+",height="+(window.screen.availHeight-70));
      // this.$router.push(url);
      let isClose = 1;
      let this_ = this;
      //关闭open页面时刷新父页面列表
      let loop = setInterval(function() {
        if (windowObj.closed && isClose == 1) {
          isClose--;
          //这里写刷新代码
          this_.search("find");
          clearInterval(loop);
        }
      }, 1000);

    },
    //子组件传值父组件(我的请求分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let querys = [{
          property:"a.status_",
          value:"draft",
          operation:"NOT_EQUAL",
          relation:"AND"
        }]
        let pageBean = { pageBean: this.pagination,querys:querys };
        this.$store
          .dispatch("storeProcess/getMyRequestByPagination", pageBean)
          .then(() => {
            //页面加载调用myRequest.js里面的分页方法
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      let pageBean = {};
      return process.getMyRequestCount(pageBean);
    }
  },
  created() {
    window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND"
      });
    }
    querys.push({
      property:"a.status_",
      value:"draft",
      operation:"NOT_EQUAL",
      relation:"AND"
    })
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getMyRequestByPagination", pageBean)
      .then(() => {
        //页面加载调用myRequest.js里面的分页方法
        this.fullscreenLoading = false;
      });
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
  /deep/ .el-badge__content.is-dot{
    margin-top: 10px !important;
    margin-right: 8px !important;
    width: 6px !important;
    height: 6px !important;
  }
/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
  padding-right: 8px;
}
/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 

/deep/ .request{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #E70D0D !important;
  margin-right: 4px !important;
}

/deep/ .el-badge{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .el-collapse-item__header{
  padding: 0px 24px 0px 0px !important;
  margin: 0px !important;
}

    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }
  .form_select__status {
      margin-right: 10px;
      display: flex;
      flex-direction: row;
    }
    .form_select__status {
      width: 100%;
      p {
        white-space: nowrap;
        width: 30px;
        margin: 8px;
      }
    }
/deep/.el-table th{
  height: 48px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}
// /deep/.el-table--border tr:nth-child(even){
//     background: rgb(240, 241, 241);
// }

/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
  background-color:#EDF6FB !important;
    .myRequest-subject{
      color: #1890FF !important;
    }
    .myRequest-subject-read{
      color: #1890FF !important;
    }
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}



/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.myRequest-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
}
.el-header {
  border-bottom: 1.5px solid #ededed;
}
/deep/.el-tag {
  padding-left: 3px;
  padding-right: 3px;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}

.myRequest-subject {
  cursor: pointer;
}

.myRequest-subject {
  color: $--theme-color;
}

.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}
/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.request_content {
  padding: 0px 24px 0px 24px;
}
/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 0px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.form-content-wrap {
  padding: 0 24px 24px 24px;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
    scrollbar-width: none;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin: 8px 0 0 24px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    /deep/.el-date-editor--datetimerange.el-input__inner {
      width: 180px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_select__status {
      margin-right: 10px;
      display: flex;
      flex-direction: row;
    }
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
    .form_date_picker {
      p {
        width: 54px;
        margin: 8px;
      }
    }
    .form_select__status {
      width: 100%;
      p {
        white-space: nowrap;
        width: 30px;
        margin: 8px;
      }
    }
  }
}
</style>
